<template>
  <div>
    <el-row
      style="
        text-align: center;
        font-size: 16px;
        color: #303133;
        line-height: 18px;
        cursor: pointer;
        padding-top: 10px;
      "
    >
      <span
        >チャートパネル
        <i v-if="allBarShowFlg" class="el-icon-arrow-up"></i>
        <i v-else class="el-icon-arrow-down"></i>
      </span>
    </el-row>
    <el-row>
      <div
        v-if="$root.barscrollFlg === 'true' && allBarShowFlg"
        style="
          width: 100%;
          height: 200px;
          float: left;
          overflow: hidden;
        "
      >
        <draggable
          v-model="$root.usedChartChatList"
          :options="{ disabled: !$root.editMode, animation: 300 }"
        >
          <component
            v-for="(chart, index) in $root.usedChartChatList"
            :is="chart.name"
            :title="chart.name"
            :displayTitle="chart.displayName"
            :key="index"
            :key1="index"
          ></component>
        </draggable>
      </div>
      <div
        v-else-if="$root.barscrollFlg === 'true' && !allBarShowFlg"
        style="width: 100%; float: left; overflow-y: auto; overflow-x: hidden"
      >
        <draggable
          v-model="$root.usedChartChatList"
          :options="{ disabled: !$root.editMode, animation: 300 }"
        >
          <component
            v-for="(chart, index) in $root.usedChartChatList"
            :is="chart.name"
            :title="chart.name"
            :displayTitle="chart.displayName"
            :key="index"
            :key1="index"
          ></component>
        </draggable>
      </div>
      <div v-else style="width: 100%; height: 200px; float: left">
        <draggable
          v-model="$root.usedChartChatList"
          :options="{ disabled: !$root.editMode, animation: 300 }"
        >
          <component
            v-for="(chart, index) in $root.usedChartChatList"
            :is="chart.name"
            :title="chart.name"
            :displayTitle="chart.displayName"
            :key="index"
            :key1="index"
          ></component>
        </draggable>
      </div>

      <el-dialog
        :title="$root.currentPopUpTitle"
        :visible.sync="$root.popUpDisplay"
        class="historyDailog"
      >
        <hr />
        <echarts
          :auto-resize="true"
          :option="$root.currentChartData"
          style="height: 75vh"
        />
      </el-dialog>
    </el-row>
    <el-row
      v-if="$root.chatTable"
      style="
        text-align: center;
        font-size: 16px;
        color: #303133;
        line-height: 18px;
        cursor: pointer;
        padding: 5px 0 5px 0;
      "
    >
      <span
        style="position: absolute; width: 100%; display: flow-root"
        @click="ShowTableDetail"
        v-if="chatTableShowFlg"
        >発生中のチャット応対
        <i class="el-icon-arrow-up"></i>
      </span>
      <span
        style="position: absolute; width: 100%; display: flow-root"
        @click="ShowTableDetail"
        v-else
        >発生中のチャット応対
        <i class="el-icon-arrow-down"></i>
      </span>
      <span
        @click="changeTabelData"
        style="
          float: right;
          font-size: 14px;
          color: #0076d3;
          position: inherit;
          z-index: 999;
        "
        >日次集計データ
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </el-row>
    <el-row
      v-else
      style="
        text-align: center;
        font-size: 16px;
        color: #303133;
        line-height: 18px;
        cursor: pointer;
        padding: 5px 0 5px 0;
      "
    >
      <span
        @click="changeTabelData"
        style="
          float: left;
          font-size: 14px;
          color: #0076d3;
          position: inherit;
          z-index: 999;
        "
      >
        <i class="el-icon-d-arrow-left"></i>
        発生中のチャット応対
      </span>
      <span
        style="position: absolute; width: 100%; display: flow-root"
        @click="ShowTableDetail"
        v-if="chatTableShowFlg"
        >日次集計データ
        <i class="el-icon-arrow-up"></i>
      </span>
      <span
        style="position: absolute; width: 100%; display: flow-root"
        @click="ShowTableDetail"
        v-else
        >日次集計データ
        <i class="el-icon-arrow-down"></i>
      </span>
    </el-row>
    <el-row>
      <ChatDetailTable></ChatDetailTable>
    </el-row>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ChatDetailTable from "@/components/charts/ChatDetailTable.vue";

export default {
  name: "RealTimeChatMain",
  data() {
    return {
      allBarShowFlg: true,
      chatTableShowFlg: true,
    };
  },
  components: {
    draggable,
    ChatDetailTable,
  },
  methods: {
    ShowDetail() {
      if (this.allBarShowFlg == true) {
        this.allBarShowFlg = false;
      } else {
        this.allBarShowFlg = true;
      }
    },
    ShowTableDetail() {
      if (this.chatTableShowFlg == true) {
        this.chatTableShowFlg = false;
        this.$root.chatTableHeight = "100%";
      } else {
        this.chatTableShowFlg = true;
        this.$root.chatTableHeight = "390";
      }
    },
    changeTabelData() {
      if (this.$root.chatTable == true) {
        this.$root.chatTable = false;
      } else {
        this.$root.chatTable = true;
      }
    },
  },
};
</script>
<style>
.echarts {
  width: inherit !important;
}
.no-search {
  margin-bottom: 27px;
}
.sub-view .sub-title {
  background-color: lightgrey;
  padding: 5px;
  margin-bottom: 0;
  font-weight: bold;
}

.sub-view .el-icon-close,
.sub-view .el-icon-zoom-in {
  float: right;
}

.el-icon-close:hover,
.el-icon-zoom-in:hover {
  cursor: pointer;
}

.el-alert {
  margin-top: 5px;
}

.el-dialog__body {
  padding: 10px 20px;
}

.el-dialog__title {
  font-weight: bold;
}

.el-dialog {
  margin-top: 10vh !important;
  /* width: 70%;
  min-height: 80%; */
}

.opacity {
  color: #646464;
  opacity: 0.5;
  width: 100%;
}
</style>
